import $ from 'jquery';
window.jQuery = $;
window.$ = $;
global.jQuery = $;
const jqueryUi = require('./modules/jquery-ui.min.js');
const bootstrap = require('bootstrap');
const scripts = require('./modules/scripts.js');
const scroll = require('./modules/scroll.js');
const nav = require('./modules/nav.js');
